<template>
  <!-- <link rel="stylesheet" href="https://cdn.brackethq.com/styles/style-005b.css" /> -->
  <div class="viewport modern modern-dark">
    <div class="viewport-scroll">
      <div class="viewport-area mt-3" style="width: 2400px;">
        <div class="preview-wrapper">
          <!-- <Spin v-if="loading" fix>
            <Icon class="demo-spin-icon-load" size="40" type="ios-loading"></Icon>
            <div>{{ $t("global.loading") }}</div>
          </Spin> -->
          <div class="preview dates-shown times-shown locations-shown" :class="'preview zoom-' + zoom[zoomQty]">
            <Group v-if="type === 'group' && qty && renderComponent" />
            <Circuit v-if="type === 'circuit' && spec && renderComponent" />
          </div>
        </div>
      </div>
    </div>
    <MatchCircuitModal v-if="circuitModal" :match="selectedMatch" :competition="competition" @close="(e) => close(e)" />
    <div class="zoom">
      <div class="zoom-out" @click="() => zoomOut()"></div>
      <div class="zoom-num">{{ this.zoom[this.zoomQty] }}%</div>
      <div class="zoom-in" @click="() => zoomIn()"></div>
    </div>
  </div>
</template>
<script>
import Circuit from "./Circuit.vue";
import Group from "./Group.vue";
import bracketsMixin from "./bracketsMixin";
import MatchCircuitModal from "../schemes/formats/MatchCircuitModal.vue";


export default {
  name: 'BracketsView',
  components: { Group, Circuit, MatchCircuitModal },
  data() {
    return bracketsMixin
  },
  methods: {
    zoomOut() {
      console.log(this.zoomQty)
      if (1 < this.zoomQty) this.zoomQty--
    },
    zoomIn() {
      if (8 > this.zoomQty) this.zoomQty++
    }
  },
  created() {

  }
};
</script>
<style scoped>
@import './brackets.css';

/* .viewport {
  position: relative;
  padding-left: 0;
  padding-top: 0;
}

.viewport .viewport-scroll {
  padding-right: 0;
  padding-bottom: 0;
} */
</style>



// WEBPACK FOOTER //
// src/components/competitions/brackets/BracketsView.vue